<div [formGroup]='parent' *ngIf="question.controlStyle === 'InputBox_standard'">
  <div *ngIf="question.questionText" class="question-style normal-ques-style mb-10">

    <span>
      {{question.questionText}}
    </span>
    <div class="info-icon d-view" *ngIf="question.helpText">
      <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)">
      </app-tool-tip-notification>
    </div>
    <div class="info-icon mt-view" *ngIf="question.helpText">
      <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)" 
      (onDisplayMobileTooltipEmitter)="displayDrpTooltipMessage(question)">
      </app-tool-tip-notification>
      
      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
      (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
    </div>
  </div>
  <ng-container *ngIf="rangeModalObject && rangeModalObject.maxValue && rangeModalObject.decimalRange">
    <input class="Rectangle-157-Copy-3 btn-border mobile1" onpaste="return false"
      [attr.aria-label]="question.questionText?question.questionText:controlName" [formControlName]="controlName"
      id="{{domId }}" [(ngModel)]="selectedValue" (keyup)="setValueToFrom(false)" (blur)="setValueToFormOnBlur()"
      DecimalPlaces="2" OnlyNumber="true" [minValue]="0" [maxValue]="rangeModalObject.maxValue" [value]=""
      inputmode="numeric" />
  </ng-container>

  <ng-container *ngIf="rangeModalObject && rangeModalObject.maxValue && !rangeModalObject.decimalRange">
    <input class="Rectangle-157-Copy-3 btn-border mobile2"
      onpaste="return false" [attr.aria-label]="question.questionText?question.questionText:controlName"
      [formControlName]="controlName" id="{{domId }}" [(ngModel)]="selectedValue" (keyup)="setValueToFrom(false)"
      (blur)="setValueToFormOnBlur()" OnlyNumber="true" [minValue]="rangeModalObject.minValue"
      [maxValue]="rangeModalObject.maxValue" [maxlength]="3" [value]=""
      onkeypress="return event.charCode >= 48 && event.charCode <= 57" inputmode="numeric" />

  </ng-container>

  <ng-container *ngIf="!rangeModalObject">
    <input class="Rectangle-157-Copy-3 btn-border mobile3" onpaste="return false"
      [attr.aria-label]="question.questionText?question.questionText:controlName" [formControlName]="controlName"
      id="{{domId }}" [(ngModel)]="selectedValue" (keyup)="setValueToFrom(false)" (blur)="setValueToFormOnBlur()"
      [value]="" [maxlength]="3"
      onkeypress="return !((event.charCode >= 32 && event.charCode <= 47) || (event.charCode >= 58 && event.charCode <= 64) 
      || (event.charCode >= 91 && event.charCode <= 96) || (event.charCode >= 123 && event.charCode <= 126))"
      inputmode="numeric"
      />
  </ng-container>
</div>

<div [formGroup]='parent'
  *ngIf="question.controlStyle !== 'InputBox_standard' && question.controlStyle !== 'InputBox_image_3number'">

  <div class="toggleButton" *ngIf="!rangeModalObject.decimalRange">
    <div class="radio-input">
      <input [formControlName]="controlName" onpaste="return false"
        [attr.aria-label]="question.questionText?question.questionText:controlName" [(ngModel)]="selectedValue"
        id="{{question.id}}-input" [value]="" type="text" class="number-input btn-border" [maxlength]="3"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57" (keyup)="setValueToFrom(false)"
        (blur)="setValueToFormOnBlur()" inputmode="numeric">
    </div>
    <span class="span-text clear-all">{{question.questionText}}</span>
  </div>
  <div class="toggleButton" *ngIf="rangeModalObject.decimalRange">
    <div class="radio-input">
      <input [formControlName]="controlName" onpaste="return false"
        [attr.aria-label]="question.questionText?question.questionText:controlName" [(ngModel)]="selectedValue"
        id="{{question.id}}-input" [value]="" type="text" class="number-input btn-border" DecimalPlaces="2"
        OnlyNumber="true" [minValue]="0" [maxValue]="rangeModalObject.maxValue" (keyup)="setValueToFrom(false)"
        (blur)="setValueToFormOnBlur()" inputmode="numeric">
    </div>
    <span class="span-text">{{question.questionText}}</span>
  </div>
</div>

<div [formGroup]='parent' *ngIf="question.controlStyle === 'InputBox_image_3number'">
  <div class="col-md-6 container bigContainer5">
    <div class="col-md-4">
      <img [id]="question.id" src="{{imagePath}}" alt="" class="Alcopop">
    </div>
    <div class="col-md-2 mar-t">
      <input [formControlName]="controlName" (keyup)="setValueToFrom(false)"
        [attr.aria-label]="question.questionText?question.questionText:controlName" (blur)="setValueToFormOnBlur()"
        [(ngModel)]="selectedValue" id="{{question.id}}-input" type="text" class="text-input btn-border"
        OnlyNumber="true" minValue="0" maxlength="3" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        [maxValue]="rangeModalObject.maxValue" inputmode="numeric" />
    </div>
    <div class="col-md-6 Glasses-of-Wine ">
      <span [ngClass]="(question.questionText.length < 16 && !question.questionLabel) ? 'middle-align': ''"
        [id]="question.id">{{question.questionText}} </span>
      <p id="{{question.id}}-label" class="per-day mt-3">{{question.questionLabel}}</p>
    </div>
  </div>
</div>

<div [ngClass]="{'margin-bottom-16': parent.get(controlName).errors.invalid}" class="form-validation-error" *ngIf="!toggleBtnFlag && parent.get(controlName).touched
                        &&
                        parent.get(controlName).touched && parent.get(controlName).errors">
  <i class="icon icon-error" aria-hidden="true"></i>
  <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.required" aria-hidden="false"
    role="error" aria-live="polite">Please enter a value</p>
  <p [id]="pageName+'-'+controlName +'-error'"
    *ngIf="(parent.get(controlName).errors.min || parent.get(controlName).errors.invalid)" aria-hidden="false"
    role="error" aria-live="polite">Please enter a value for {{rangeModalObject.valueKey}} between
    {{rangeModalObject.minValue}} and {{rangeModalObject.maxValue}}</p>
</div>